import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Dropdown, DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';

/*
 * Style.
 */

const StyledDropdownDiv = styled.div`
  padding: 5px 0;
`;

/*
 * Component.
 */

export const QuickSettingsDropdown: FC<PropsWithChildren<DropdownProps>> = ({children, ...props}) => (
  <Dropdown {...props}>
    <StyledDropdownDiv>{children}</StyledDropdownDiv>
  </Dropdown>
);
